import { changetheme } from '@/app/store/layout/layout-action'
import { getLayoutColor } from '@/app/store/layout/layout-selector'
import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core'
import { RouterModule, Router } from '@angular/router'
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { SimplebarAngularModule } from 'simplebar-angular'
import { TabItems } from './data'
import { AuthenticationService } from '@/app/core/service/auth.service'
import { TranslateDirective, TranslatePipe, TranslateService } from '@ngx-translate/core'
import { HttpTransportType, HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { BellNotificationsService } from '@/app/core/service/bellNotifications.service';
import { CommonModule } from '@angular/common';
import { UtilsService } from '@/app/core/service/utils.service'
import { UsersService } from '@/app/core/service/users.service'
@Component({
  selector: 'TopBar',
  standalone: true,
  imports: [
    NgbDropdownModule,
    SimplebarAngularModule,
    NgbNavModule,
    RouterModule,
    CommonModule,
    FormsModule,
    NgbDropdownModule, NgbNavModule, TranslatePipe, TranslateDirective
  ],
  templateUrl: './topbar.component.html',
  styles: ``,
})
export class TopbarComponent implements OnInit {
  userName = localStorage.getItem("userName") ?? "";
  tabItems = TabItems
  store = inject(Store)
  utilsService = inject(UtilsService);
  scrollY = 0
  notificationsCount: number | null = null;
  languageSetter = localStorage.getItem("lang") ?? "";
  languageImageSetter = localStorage.getItem("lang_image") ?? "";
  defaultLanguageImage: string = this.languageSetter === "" ? "assets/images/flags/spain_flag.jpg" : this.languageImageSetter;
  newMsg = '';
  userInfo: any;
  private hubConnection!: HubConnection;
  private notificationSubject = new Subject<string>();
  initialPreviewUrl: string | null = null;
  public notifications$ = this.notificationSubject.asObservable();
  public usersService = inject(UsersService);

  @Output() mobileMenuButtonClicked = new EventEmitter()

  constructor(public bellNotificationsService: BellNotificationsService, private router: Router, private authenticationService: AuthenticationService, private translate: TranslateService) {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()
    this.hubConnection = new HubConnectionBuilder()
      .withUrl('https://api.bencash.net/notificationHub', {
        transport: HttpTransportType.WebSockets,
        skipNegotiation: true,
        accessTokenFactory: () => {
          // return your current JWT; Angular will append ?access_token=…
          return localStorage.getItem("userId") ?? "0";
        }
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection.on('ReceiveNotification', (msg: string) => {
      this.notificationSubject.next(msg);
    });

    this.startConnection();
  }

  ngOnInit(): void {
    this.userInfo = this.authenticationService.UserInfo;
    this.initialPreviewUrl = this.authenticationService.UserInfo.photo ?? null
    this.utilsService.GET_METHOD("/UserNotifications/QtyWithOutRead", true, true).then((response: any) => {
      this.notificationsCount = response?.data;
    });
  }

  goToNotifications() {
    switch (this.authenticationService.UserInfo.type) {
      case 1:
        this.router.navigate(["/user/home/notifications"]);
        break;
      case 2:
        this.router.navigate(["/subagent/home/notifications"]);
        break;
      case 4:
        this.router.navigate(["/regional-manager/home/notifications"]);
        break;
    }
  }

  getAllNotifications() {
    this.bellNotificationsService.getAmeroNotifications();
    this.bellNotificationsService.getServicesNotifications();
    this.bellNotificationsService.getSendsNotifications();
  }

  private async startConnection() {
    try {
      await this.hubConnection.start();
      console.log('SignalR Connected');
      this.sendNotification("1");
    } catch (err) {
      console.error('Error connecting to SignalR:', err);
      setTimeout(() => this.startConnection(), 5000);
    }
  }

  readNotification(id: number, transactionId: number, option: number) {
    console.log("🚀 ~ TopbarComponent ~ readNotification ~ id:", id)

    switch (option) {
      case 1:
        this.bellNotificationsService.readNotification(id);
        this.goToPage('/apps/ecommerce/amero/view/' + transactionId + '/1')
        break;
      case 2:
        this.bellNotificationsService.readNotification(id);
        this.goToPage('/apps/ecommerce/transactionsservices');

        break;
      case 3:
        this.bellNotificationsService.readNotification(id);
        this.goToPage('/apps/ecommerce/send');
        break;
    }

  }

  // (Optional) client-side send
  public sendNotification(message: string) {
    this.hubConnection.invoke('SendNotification', message)
      .catch(err => console.error(err));
  }

  send() {
    if (this.newMsg.trim()) {
      this.sendNotification(this.newMsg);
      this.newMsg = '';
    }
  }

  toggleMobileMenu() {
    this.mobileMenuButtonClicked.emit()
  }

  logout() {
    this.authenticationService.logout();
  }

  goToPage(url: string) {
    this.router.navigate([url]);
  }

  changeLanguage(lang: string, langImage: string) {
    localStorage.setItem("lang", lang);
    localStorage.setItem("lang_image", langImage);
    this.defaultLanguageImage = langImage;
    this.translate.use(lang);
  }
  // Change Theme
  changeTheme() {
    const color = document.documentElement.getAttribute('data-bs-theme')
    if (color == 'light') {
      this.store.dispatch(changetheme({ color: 'dark' }))
      this.usersService.setDarkMode(1);
    } else {
      this.store.dispatch(changetheme({ color: 'light' }))
      this.usersService.setDarkMode(0);
    }

    this.store.select(getLayoutColor).subscribe((color) => {
      document.documentElement.setAttribute('data-bs-theme', color)
    })

  }
  handleScroll = () => {
    this.scrollY = window.scrollY
  }
}
